/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  's-await': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" fill-rule="evenodd" d="M10 0C4.477 0 0 4.477 0 10s4.477 10 10 10 10-4.477 10-10S15.523 0 10 0zm5 12.11a.39.39 0 01-.39.39H7.89a.382.382 0 01-.116-.018l-.005-.002a.39.39 0 01-.269-.37V5.39A.39.39 0 017.89 5h1.72a.39.39 0 01.39.39V10h4.61a.39.39 0 01.39.39v1.72z" _fill="#c4c4c4"/>'
  }
})
